const Modal = {
  baseStyle: {
    closeButton: {
      top: 3,
      insetEnd: 3,
    },
    dialog: {
      marginY: '10rem',
      borderRadius: '12px',
    },
  },
};

export default Modal;
